/* eslint-disable jsx-a11y/no-static-element-interactions */
/* TODO A11Y replace react-select with an accessible alternative */
import cn from 'classnames'
import type {FormikErrors} from 'formik'
import type {KeyboardEventHandler, ReactChildren, ChangeEvent} from 'react'
import type React from 'react'
import {Component} from 'react'
import type {ReactSelectProps} from 'react-select'
import ReactSelect from 'react-select'

import {ChevronDown, ChevronUp, Close} from '@pleo-io/telescope-icons'

import styles from './select.module.css'

interface OptionProps {
    children?: ReactChildren
    className?: string
    isFocused?: boolean
    onFocus: Function
    onSelect: Function
    option: any
}

class Option extends Component<OptionProps> {
    handleMouseDown = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault()
        event.stopPropagation()
        this.props.onSelect(this.props.option, event)
    }

    handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
        this.props.onFocus(this.props.option, event)
    }

    handleMouseMove = (event: React.MouseEvent<HTMLElement>) => {
        if (this.props.isFocused) {
            return
        }
        this.props.onFocus(this.props.option, event)
    }

    render() {
        const {className, option, children} = this.props
        return (
            <div
                data-testid="component-select-option"
                className={cn(className, {
                    ['is-group-label']: option.groupLabel,
                    ['is-noTag-label']: option.noTag,
                })}
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                title={option.title}
                data-generic-ui="select-legacy"
            >
                {children}
            </div>
        )
    }
}

class PleoReactSelect extends ReactSelect<any> {}

export interface SelectProps extends ReactSelectProps<any> {
    hasOptGroups?: boolean
    label?: string
    border?: boolean | string
    block?: boolean
    onBlur?: any
    ref?: any
    isMulti?: boolean
    error?: FormikErrors<any> | FormikErrors<any>[] | string[] | string | null
    testId?: string
}

interface SelectState {
    value: any
}

/**
 * @deprecated Use '@pleo-io/telescope' Select
 */
class Select extends Component<SelectProps, SelectState> {
    state: SelectState = {
        value: '',
    }

    selectRef: any = null

    handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({value: event.target.value})
    }

    filterOptions = (option: any, filter: string) => {
        if (filter) {
            return option.label.toLowerCase().includes(filter.toLowerCase())
        }
        return true
    }

    onInputChange = (value: string) => {
        this.setState({value})
    }

    stopEventPropagation: KeyboardEventHandler<any> = (e) => {
        e.stopPropagation()
    }

    focus = () => {
        this.selectRef && this.selectRef.focus && this.selectRef.focus()
    }

    isOpened = () => {
        return this.selectRef && this.selectRef.menuContainer
    }

    render() {
        const {
            className,
            options = [],
            value,
            label,
            border,
            block,
            hasOptGroups,
            onBlur, // onBlur needs to be overriden for redux-form see https://github.com/erikras/redux-form/issues/1185
            error,
            testId,
            disabled,
            ...restProps
        } = this.props

        const clonedOptions = [...options]

        const hint = <div className={styles.error}>{error}</div>

        const classes = cn(className, {
            [styles.optGroups]: hasOptGroups,
            [styles.borderless]: border === false,
            [styles.slim]: border === 'slim',
            [styles.invalid]: !!error,
        })
        const select = (
            <div
                className={cn(className, styles.select, {
                    [styles.block]: block,
                })}
                data-testid={testId}
            >
                {!!error && hint}
                <PleoReactSelect
                    ref={(ref) => {
                        this.selectRef = ref
                    }}
                    arrowRenderer={({isOpen}: any) =>
                        isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />
                    }
                    // @ts-ignore-next-line method exists, but @types/react-select doesn't know.
                    // There's no upgrade available for the version types we use, so considering
                    // this is legacy, ignoring seemed ok.
                    clearRenderer={() => <Close size={16} />}
                    options={clonedOptions}
                    ignoreAccents={false}
                    value={value}
                    className={classes}
                    onBlur={() => onBlur && onBlur(value)}
                    filterOption={this.filterOptions}
                    onInputChange={this.onInputChange}
                    optionComponent={Option}
                    onInputKeyDown={this.stopEventPropagation}
                    tabIndex={disabled ? '-1' : undefined}
                    disabled={disabled}
                    {...restProps}
                />
            </div>
        )

        if (label) {
            return (
                <label className={styles.label}>
                    <span className={styles.labelText}>{label}</span>
                    {select}
                </label>
            )
        }

        return select
    }
}

export default Select
/* eslint-enable jsx-a11y/no-static-element-interactions */
